const getMrTimings = () => {
    return {
        stats: {
            total_accepted_count: 9,
            total_approved_count: 34,
            total_commented_count: 34,
            mrs: [
                {
                    mr_id: "1879323598",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/android-onxmaps",
                    in_progress_duration_sec: 286483,
                    under_review_duration_sec: 229229,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1894851405",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/android-onxmaps",
                    in_progress_duration_sec: 83489,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1942892797",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/android-onxmaps",
                    in_progress_duration_sec: 1991595,
                    under_review_duration_sec: 1656002,
                    approval_to_merge_duration_sec: 170213,
                },
                {
                    mr_id: "1931529768",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/android-onxmaps",
                    in_progress_duration_sec: 324958,
                    under_review_duration_sec: 0,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1967205383",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/android-onxmaps",
                    in_progress_duration_sec: 80447,
                    under_review_duration_sec: 858008,
                    approval_to_merge_duration_sec: 103660,
                },
                {
                    mr_id: "1976876266",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/android-onxmaps",
                    in_progress_duration_sec: 605828,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1926905135",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/ios-onxmaps",
                    in_progress_duration_sec: 1768,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1890736322",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/ios-onxmaps",
                    in_progress_duration_sec: 95326,
                    under_review_duration_sec: 98818,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1896792989",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/ios-onxmaps",
                    in_progress_duration_sec: 104851,
                    under_review_duration_sec: 72892,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1928906518",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/ios-onxmaps",
                    in_progress_duration_sec: 56513,
                    under_review_duration_sec: 18287,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1972315426",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/ios-onxmaps",
                    in_progress_duration_sec: 715,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1645030921",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/trailcams",
                    in_progress_duration_sec: 918,
                    under_review_duration_sec: 655,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1829962388",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/trailcams",
                    in_progress_duration_sec: 14,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1974682780",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/trailcams",
                    in_progress_duration_sec: 0,
                    under_review_duration_sec: 78958,
                    approval_to_merge_duration_sec: 0,
                },
                {
                    mr_id: "1929324135",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/ios-onxmaps",
                    in_progress_duration_sec: 4007,
                    under_review_duration_sec: 11055,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1978454761",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/ios-onxmaps",
                    in_progress_duration_sec: 340056,
                    under_review_duration_sec: 1213,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1809927387",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/trailcams",
                    in_progress_duration_sec: 338,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1885180316",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/trailcams",
                    in_progress_duration_sec: 7499,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1976783277",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/trailcams",
                    in_progress_duration_sec: 2,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1896212142",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/trailcams",
                    in_progress_duration_sec: 30,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1930679023",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/trailcams",
                    in_progress_duration_sec: 0,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1970017060",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/trailcams",
                    in_progress_duration_sec: 171,
                    under_review_duration_sec: 0,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1933129291",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/ios-onxmaps",
                    in_progress_duration_sec: 6019,
                    under_review_duration_sec: 179,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1967149897",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/ios-onxmaps",
                    in_progress_duration_sec: 180947,
                    under_review_duration_sec: 2493,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1971917461",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/ios-onxmaps",
                    in_progress_duration_sec: 720,
                    under_review_duration_sec: 22192,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1864552589",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/webmap-onxmaps",
                    in_progress_duration_sec: 13647,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1903604409",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/webmap-onxmaps",
                    in_progress_duration_sec: 780,
                    under_review_duration_sec: 12119,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1907715152",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/webmap-onxmaps",
                    in_progress_duration_sec: 158888,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1929221180",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/webmap-onxmaps",
                    in_progress_duration_sec: 4553,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1962771256",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/webmap-onxmaps",
                    in_progress_duration_sec: 418796,
                    under_review_duration_sec: 3123,
                    approval_to_merge_duration_sec: 701895,
                },
                {
                    mr_id: "1981897209",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/carto",
                    in_progress_duration_sec: 473,
                    under_review_duration_sec: 78157,
                    approval_to_merge_duration_sec: 80776,
                },
                {
                    mr_id: "1982198129",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/webmap-onxmaps",
                    in_progress_duration_sec: 3193,
                    under_review_duration_sec: 58594,
                    approval_to_merge_duration_sec: 100336,
                },
                {
                    mr_id: "1982142138",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/webmap-onxmaps",
                    in_progress_duration_sec: 342,
                    under_review_duration_sec: 1364,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1978704805",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/ios-onxmaps",
                    in_progress_duration_sec: 255579,
                    under_review_duration_sec: 0,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1970039612",
                    hostname_repo_full_name:
                        "https://api.github.com:onXmaps/atlantis-ci-cloudbuild",
                    in_progress_duration_sec: 88,
                    under_review_duration_sec: 0,
                    approval_to_merge_duration_sec: 780392,
                },
                {
                    mr_id: "1917360902",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/android-onxmaps",
                    in_progress_duration_sec: 4485,
                    under_review_duration_sec: 438306,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1978394673",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/trailcams",
                    in_progress_duration_sec: 359898,
                    under_review_duration_sec: 350,
                    approval_to_merge_duration_sec: 66865,
                },
                {
                    mr_id: "1985756903",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/trailcams",
                    in_progress_duration_sec: 384,
                    under_review_duration_sec: 2700,
                    approval_to_merge_duration_sec: 9029,
                },
                {
                    mr_id: "1985787985",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/webmap-onxmaps",
                    in_progress_duration_sec: 149768,
                    under_review_duration_sec: 1438,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1920789020",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/trailcams",
                    in_progress_duration_sec: 196,
                    under_review_duration_sec: 3464700,
                    approval_to_merge_duration_sec: 0,
                },
                {
                    mr_id: "1960642799",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/android-onxmaps",
                    in_progress_duration_sec: 3026446,
                    under_review_duration_sec: 266243,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1910278918",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/ios-onxmaps",
                    in_progress_duration_sec: 559,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1924764107",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/ios-onxmaps",
                    in_progress_duration_sec: 427714,
                    under_review_duration_sec: 3302,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1894704670",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/trailcams",
                    in_progress_duration_sec: 199,
                    under_review_duration_sec: 151925,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1938663837",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/trailcams",
                    in_progress_duration_sec: 1805668,
                    under_review_duration_sec: 2674,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1962828841",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/webmap-onxmaps",
                    in_progress_duration_sec: 426,
                    under_review_duration_sec: 1057,
                    approval_to_merge_duration_sec: 709681,
                },
                {
                    mr_id: "1981887193",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/webmap-onxmaps",
                    in_progress_duration_sec: 353058,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1892686615",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/weather",
                    in_progress_duration_sec: 440,
                    under_review_duration_sec: 83011,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1931306523",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/webmap-onxmaps",
                    in_progress_duration_sec: 136,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1938722729",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/webmap-onxmaps",
                    in_progress_duration_sec: 1457,
                    under_review_duration_sec: 61702,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1967002122",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/webmap-onxmaps",
                    in_progress_duration_sec: 593366,
                    under_review_duration_sec: 258797,
                    approval_to_merge_duration_sec: 338658,
                },
                {
                    mr_id: "1983535169",
                    hostname_repo_full_name: "https://api.github.com:onXmaps/webmap-onxmaps",
                    in_progress_duration_sec: 683,
                    under_review_duration_sec: 2433,
                    approval_to_merge_duration_sec: null,
                },
            ],
            in_progress_duration_adj_avg: 82579,
            in_progress_duration_avg: 226037,
            in_progress_duration_median: 4246,
            in_progress_duration_25th: 416,
            in_progress_duration_75th: 199605,
            "90thInProgressDuration": 426822,
            in_progress_duration_95th: 1145756,
            in_progress_duration_99th: 2498672,
            under_review_duration_adj_avg: 54463,
            under_review_duration_avg: 220610,
            under_review_duration_median: 11587,
            under_review_duration_25th: 1326,
            under_review_duration_75th: 86963,
            under_review_duration_90th: 352275,
            under_review_duration_95th: 1057506,
            under_review_duration_99th: 2831656,
            approved_to_merge_duration_adj_avg: 196429,
            approved_to_merge_duration_avg: 255125,
            approved_to_merge_duration_median: 101998,
            approved_to_merge_duration_25th: 52406,
            approved_to_merge_duration_75th: 429467,
            approved_to_merge_duration_90th: 708902,
            approved_to_merge_duration_95th: 741501,
            approved_to_merge_duration_99th: 772614,
            timeseries: [
                {
                    week: "2024-07-15 00:00:00",
                    mrs: [
                        {
                            mr_id: "1962771256",
                            hostname_repo_full_name:
                                "https://api.github.com:onXmaps/webmap-onxmaps",
                            in_progress_duration_sec: 418796,
                            under_review_duration_sec: 3123,
                            approval_to_merge_duration_sec: 701895,
                        },
                        {
                            mr_id: "1974682780",
                            hostname_repo_full_name: "https://api.github.com:onXmaps/trailcams",
                            in_progress_duration_sec: 0,
                            under_review_duration_sec: 78958,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1962828841",
                            hostname_repo_full_name:
                                "https://api.github.com:onXmaps/webmap-onxmaps",
                            in_progress_duration_sec: 426,
                            under_review_duration_sec: 1057,
                            approval_to_merge_duration_sec: 709681,
                        },
                        {
                            mr_id: "1967002122",
                            hostname_repo_full_name:
                                "https://api.github.com:onXmaps/webmap-onxmaps",
                            in_progress_duration_sec: 593366,
                            under_review_duration_sec: 258797,
                            approval_to_merge_duration_sec: 338658,
                        },
                        {
                            mr_id: "1942892797",
                            hostname_repo_full_name:
                                "https://api.github.com:onXmaps/android-onxmaps",
                            in_progress_duration_sec: 1991595,
                            under_review_duration_sec: 1656002,
                            approval_to_merge_duration_sec: 170213,
                        },
                    ],
                    in_progress_duration_avg: 301649,
                    in_progress_duration_median: 443,
                    in_progress_duration_10th: 1,
                    in_progress_duration_25th: 66,
                    in_progress_duration_75th: 151997,
                    in_progress_duration_90th: 965780,
                    in_progress_duration_95th: 1385724,
                    in_progress_duration_99th: 1721679,
                    in_progress_duration_adj_avg: 100340,
                    under_review_duration_avg: 288375,
                    under_review_duration_median: 22192,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 1337,
                    under_review_duration_75th: 168878,
                    under_review_duration_90th: 817679,
                    under_review_duration_95th: 1236840,
                    under_review_duration_99th: 1572170,
                    under_review_duration_adj_avg: 68261,
                    approved_to_merge_duration_avg: 384089,
                    approved_to_merge_duration_median: 338658,
                    approved_to_merge_duration_10th: 68085,
                    approved_to_merge_duration_25th: 170213,
                    approved_to_merge_duration_75th: 701895,
                    approved_to_merge_duration_90th: 706567,
                    approved_to_merge_duration_95th: 708124,
                    approved_to_merge_duration_99th: 709370,
                    approved_to_merge_duration_adj_avg: 181929,
                },
                {
                    week: "2024-07-22 00:00:00",
                    mrs: [
                        {
                            mr_id: "1982198129",
                            hostname_repo_full_name:
                                "https://api.github.com:onXmaps/webmap-onxmaps",
                            in_progress_duration_sec: 3193,
                            under_review_duration_sec: 58594,
                            approval_to_merge_duration_sec: 100336,
                        },
                        {
                            mr_id: "1985756903",
                            hostname_repo_full_name: "https://api.github.com:onXmaps/trailcams",
                            in_progress_duration_sec: 384,
                            under_review_duration_sec: 2700,
                            approval_to_merge_duration_sec: 9029,
                        },
                        {
                            mr_id: "1920789020",
                            hostname_repo_full_name: "https://api.github.com:onXmaps/trailcams",
                            in_progress_duration_sec: 196,
                            under_review_duration_sec: 3464700,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1970039612",
                            hostname_repo_full_name:
                                "https://api.github.com:onXmaps/atlantis-ci-cloudbuild",
                            in_progress_duration_sec: 88,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 780392,
                        },
                        {
                            mr_id: "1978394673",
                            hostname_repo_full_name: "https://api.github.com:onXmaps/trailcams",
                            in_progress_duration_sec: 359898,
                            under_review_duration_sec: 350,
                            approval_to_merge_duration_sec: 66865,
                        },
                        {
                            mr_id: "1981897209",
                            hostname_repo_full_name: "https://api.github.com:onXmaps/carto",
                            in_progress_duration_sec: 473,
                            under_review_duration_sec: 78157,
                            approval_to_merge_duration_sec: 80776,
                        },
                        {
                            mr_id: "1967205383",
                            hostname_repo_full_name:
                                "https://api.github.com:onXmaps/android-onxmaps",
                            in_progress_duration_sec: 80447,
                            under_review_duration_sec: 858008,
                            approval_to_merge_duration_sec: 103660,
                        },
                    ],
                    in_progress_duration_avg: 146343,
                    in_progress_duration_median: 76480,
                    in_progress_duration_10th: 380,
                    in_progress_duration_25th: 526,
                    in_progress_duration_75th: 318937,
                    in_progress_duration_90th: 353742,
                    in_progress_duration_95th: 356820,
                    in_progress_duration_99th: 359282,
                    in_progress_duration_adj_avg: 100340,
                    under_review_duration_avg: 406269,
                    under_review_duration_median: 2433,
                    under_review_duration_10th: 350,
                    under_review_duration_25th: 1288,
                    under_review_duration_75th: 68376,
                    under_review_duration_90th: 858008,
                    under_review_duration_95th: 2161354,
                    under_review_duration_99th: 3204031,
                    under_review_duration_adj_avg: 68261,
                    approved_to_merge_duration_avg: 163008,
                    approved_to_merge_duration_median: 80776,
                    approved_to_merge_duration_10th: 5417,
                    approved_to_merge_duration_25th: 37947,
                    approved_to_merge_duration_75th: 101998,
                    approved_to_merge_duration_90th: 374353,
                    approved_to_merge_duration_95th: 577372,
                    approved_to_merge_duration_99th: 739788,
                    approved_to_merge_duration_adj_avg: 181929,
                },
            ],
            baseline: {
                in_progress_duration_adj_avg: 54275,
                in_progress_duration_avg: 201982,
                in_progress_duration_median: 715,
                in_progress_duration_25th: 108,
                in_progress_duration_75th: 81968,
                in_progress_duration_90th: 428725,
                in_progress_duration_95th: 1052937,
                in_progress_duration_99th: 2847212,
                under_review_duration_adj_avg: 31055,
                under_review_duration_avg: 155612,
                under_review_duration_median: 1053,
                under_review_duration_25th: 0,
                under_review_duration_75th: 68290,
                under_review_duration_90th: 364355,
                under_review_duration_95th: 670867,
                under_review_duration_99th: 2421528,
                approved_to_merge_duration_adj_avg: 121193,
                approved_to_merge_duration_avg: 220431,
                approved_to_merge_duration_median: 9029,
                approved_to_merge_duration_25th: 156,
                approved_to_merge_duration_75th: 257752,
                approved_to_merge_duration_90th: 693775,
                approved_to_merge_duration_95th: 1124039,
                approved_to_merge_duration_99th: 1560731,
            },
            inProgressDelta: -28304,
            underReviewDelta: -23408,
            approvedToMergeDelta: -75236,
        },
    };
};

export default getMrTimings;
